import { namespace } from 'vuex-class';
import { ActiviteitClass } from '@/domain/interface/activiteit/ActiviteitClass';
import { ToestelClass } from '@/domain/interface/activiteit/kenmerk/ToestelClass';
import { EindbeoordelingCommonFieldsClass } from '@/domain/interface/activiteit/eindbeoordeling/EindbeoordelingCommonFieldsClass';
import Component from 'vue-class-component';
import { Vue } from 'vue-property-decorator';
import store from '@/store';

const ActiviteitStore = namespace('Activiteit');

@Component({
  store,
})
export default class IngediendeActiviteitService extends Vue {
  public setActiviteit(activiteit: ActiviteitClass): void {
    this.updateActiviteit(activiteit);
  }

  public setToestel(toestel: ToestelClass): void {
    this.updateToestel(toestel);
  }
  public setEindbeoordeling(eindbeoordeling: EindbeoordelingCommonFieldsClass): void {
    this.updateEindbeoordeling(eindbeoordeling);
  }

  @ActiviteitStore.Action
  private updateActiviteit: (activiteit: ActiviteitClass) => void;

  @ActiviteitStore.Action
  private updateToestel: (toestel: ToestelClass) => void;

  @ActiviteitStore.Action
  private updateEindbeoordeling: (eindbeoordeling: EindbeoordelingCommonFieldsClass) => void;

  @ActiviteitStore.Getter('getActiviteit')
  public activiteit: ActiviteitClass;

  @ActiviteitStore.Getter('getToestel')
  public toestel: ToestelClass;

  @ActiviteitStore.Getter('getEindbeoordeling')
  public eindbeoordeling: EindbeoordelingCommonFieldsClass;
}
